import {Bounce, toast, ToastPosition} from "react-toastify";
import {format, parseISO} from "date-fns";
import {FilteredChannelParams} from "../state/models/ChannelResponse.ts";
import {CampaignScheduleStatus, PublicationStatus} from "../constants/enums.ts";
import {t} from "i18next";

export function formatDateFNS(date: string | Date) {
    const parsedDate = typeof date === 'string' ? parseISO(date) : date;
    return format(parsedDate, 'yyyy-MM-dd');
}

export function numberWithSpaces2(x: number | string) {
    const y = x.toString()
    const parts = y.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "");
    return parts.join(" ");
}

export function formatNumber(num: number): string {
    return num.toLocaleString("ru-RU").replace(/,/g, " ");
}

export const formatToDDMMYYYY_HHMMSS = (isoString: string): string => {
    const date = new Date(isoString);

    const pad = (n: number) => n.toString().padStart(2, '0');

    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1);
    const year = date.getFullYear();

    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
};

export const copyLink = async (
    value: string,
    title: string,
    position: ToastPosition,
    containerId: string
) => {
    const fallbackCopy = () => {
        const textarea = document.createElement("textarea");
        textarea.value = value;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
            document.execCommand("copy");
        } catch (err) {
            console.error("Fallback copy failed:", err);
        }
        document.body.removeChild(textarea);
    };

    try {
        // Попытка копирования через Clipboard API
        await navigator.clipboard.writeText(value);
    } catch (error) {
        console.warn("Clipboard API failed, using fallback:", error);
        fallbackCopy();
    }

    setTimeout(() => {
        successToastify(title, position, containerId);
    }, 100);
};

export const getToken = () => {
    let token = ''

    if (import.meta.env.DEV) {
        token = import.meta.env.VITE_APP_INIT_DATA
    } else if (import.meta.env.PROD) {
        token = window.Telegram?.WebApp?.initData || import.meta.env.VITE_APP_INIT_DATA
    }
    return token
}
export const shareBotLink = () => {
    const referralCode = getReferralCode()
    const tg = window.Telegram?.WebApp;
    const botLink = `${import.meta.env.VITE_APP_JOIN_COMMUNITY_LINK}${referralCode}`;
    const messageText = `Введи код ${referralCode} при регистрации и получай бесплатный трафик к себе в канал в автоматическом режиме`;
    const url = `https://t.me/share/url?url=${encodeURIComponent(botLink)}&text=${encodeURIComponent(messageText)}`;
    tg?.openTelegramLink(url)
    tg?.ready();
}

export const shareLink = `https://t.me/techm_test_bot/tm_test?startapp`

export const copyChannelLink = (channel: string) => {
    const link = `https://t.me/${channel}`
    copyLink(link, t('common.state.linkCopied'), 'top-center', 'publication_details_id')
}
export const checkAuth = () => {
    const item = Boolean(localStorage.getItem("isInitialized"));
    return item
}
export const unCheckAuth = () => {
    localStorage.removeItem("isInitialized");
}
export const successToastify = (title: string, position: ToastPosition, containerId: string) => {
    toast.success(title, {
        position: position,
        autoClose: 2000,
        className: 'SuccessToastify',
        icon: false,
        closeOnClick: true,
        closeButton: false,
        pauseOnHover: false,
        draggable: true,
        hideProgressBar: true,
        theme: "colored",
        containerId: containerId,
        transition: Bounce,
        style: {animationDuration: "1s"},
    });
}
export const getJoinCommunityLink = (code: string) => {
    const link = import.meta.env.VITE_APP_JOIN_COMMUNITY_LINK + code
    return link
};
export const setReferralCode = (refCode: string) => {
    const item = localStorage.setItem('refCode', refCode);
    return item
};
export const getReferralCode = () => {
    const item = localStorage.getItem('refCode');
    return item
};
export const setCurrentChannelId = (channelId: string) => {
    const item = localStorage.setItem('channelId', channelId);
    return item
};
export const getCurrentChannelId = () => {
    const item = localStorage.getItem('channelId')
    return item
};

export const setCampaignId = (campaignId: string) => {
    const item = localStorage.setItem('campaignId', campaignId);
    return item
}

export const getCampaignId = () => {
    const item = localStorage.getItem('campaignId')
    return item
}
export const removeCampaignId = () => {
    localStorage.removeItem('campaignId')
}
export const setPostId = (postId: string) => {
    const item = localStorage.setItem('postId', postId);
    return item
}
export const getPostId = () => {
    const item = localStorage.getItem('postId');
    return item
}
export const removePostId = () => {
    localStorage.removeItem('postId');
}
export const removeCurrentChannelId = () => {
    localStorage.removeItem('channelId')
}
export const setUserBalance = (balance: number) => {
    const item = localStorage.setItem('userBalance', String(balance));
    return item
};
export const getUserBalance = () => {
    const item = localStorage.getItem('userBalance');
    return item
};
export const getUserLanguage = () => {
    const item = localStorage.getItem('user_language');
    return item
};
export const setChannelMode = (mode: "engagementTraffic" | "transferTraffic") => {
    return localStorage.setItem('channelMode', mode);
}
export const getChannelMode = () => {
    return localStorage.getItem('channelMode');
}
export const setChannelFilters = (filters: FilteredChannelParams) => {
    return localStorage.setItem('channelFilters', JSON.stringify(filters));
}
export const getChannelFilters = (): FilteredChannelParams | null => {
    const data = localStorage.getItem('channelFilters');
    return data ? JSON.parse(data) as FilteredChannelParams : null;
};
export const deleteChannelFilters = () => {
    localStorage.removeItem('channelFilters');
}
export const deleteSelectedChannels = () => {
    localStorage.removeItem('selectedChannels');
};
export const setEngagementChannelFilters = (filters: FilteredChannelParams) => {
    return localStorage.setItem('engagementChannelFilters', JSON.stringify(filters));
}
export const getEngagementChannelFilters = (): FilteredChannelParams | null => {
    const data = localStorage.getItem('engagementChannelFilters');
    return data ? JSON.parse(data) as FilteredChannelParams : null;
};
export const removeSelectedEngagementChannels = () => {
    localStorage.removeItem('selectedEngagementChannels');
}
export const setParamsOfAllChannels = (data: FilteredChannelParams) => {
    localStorage.setItem('paramsOFAllChannels', JSON.stringify(data));
}
export const getParamsOfAllChannels = () => {
    const data = localStorage.getItem('paramsOFAllChannels');
    return data ? JSON.parse(data) as FilteredChannelParams : null;
}
export const setParamsOfCreateCampaign = (data: FilteredChannelParams) => {
    localStorage.setItem('paramsOfCreateCampaign', JSON.stringify(data));
}
export const getParamsOfCreateCampaign = () => {
    const data = localStorage.getItem('paramsOfCreateCampaign');
    return data ? JSON.parse(data) as FilteredChannelParams : null;
}
export const setParamsBlackListChannels = (data: FilteredChannelParams) => {
    localStorage.setItem('paramsOfBlacklistChannels', JSON.stringify(data));
}
export const getParamsBlackListChannels = () => {
    const data = localStorage.getItem('paramsOfBlacklistChannels');
    return data ? JSON.parse(data) as FilteredChannelParams : null;
}
export const setParamsFavouritesChannels = (data: FilteredChannelParams) => {
    localStorage.setItem('paramsOfFavouritesChannels', JSON.stringify(data));
}
export const getParamsFavouritesChannels = () => {
    const data = localStorage.getItem('paramsOfFavouritesChannels');
    return data ? JSON.parse(data) as FilteredChannelParams : null;
}

export const setPublication_id = (id: string) => {
    localStorage.setItem('publication_id', id);
}
export const getPublication_id = () => {
    const data = localStorage.getItem('publication_id');
    return data
}
export const removePublication_id = () => {
    localStorage.removeItem('publication_id');
}
type StatusStyle = {
    label: string;
    color: string;
};

export const getStatusDisplay = (status: string | null): StatusStyle => {

    switch (status) {
        case CampaignScheduleStatus.VERIFICATION_PENDING:
        case CampaignScheduleStatus.USER_VERIFICATION_PENDING:
            return { label: t('status.VERIFICATION_PENDING'), color: 'var(--text-color-orange)' };
        case CampaignScheduleStatus.DRAFT:
            return { label: t('status.DRAFT'), color: 'gray' };
        case CampaignScheduleStatus.Finalized:
            return { label: t('status.FINALIZED'), color: 'green' };
        case CampaignScheduleStatus.APPROVED:
            return { label: t('status.APPROVED'), color: 'green' };
        case CampaignScheduleStatus.DECLINED:
            return { label: t('status.DECLINED'), color: 'red' };
        case CampaignScheduleStatus.SCHEDULED:
            return { label: t('status.SCHEDULED'), color: 'blue' };
        case CampaignScheduleStatus.PUBLISHED:
            return { label: t('status.PUBLISHED'), color: 'green' };
        case CampaignScheduleStatus.FINISHED:
            return { label: t('status.FINISHED'), color: 'gray' };
        case CampaignScheduleStatus.FAILED:
            return { label: t('status.FAILED'), color: 'red' };
        case CampaignScheduleStatus.CANCELLED:
            return { label: t('status.CANCELLED'), color: 'gray' };
        case CampaignScheduleStatus.STOPPED:
            return { label: t('status.STOPPED'), color: 'gray' };
        case CampaignScheduleStatus.STOP_PENDING:
            return { label: t('status.STOP_PENDING'), color: 'orange' };
        default:
            return { label: t('status.UNKNOWN'), color: 'gray' };
    }
};

export const getStatusPublication = (status: PublicationStatus | null): StatusStyle => {

    switch (status) {
        case PublicationStatus.Draft:
            return { label: t('status.DRAFT'), color: 'gray' };
        case PublicationStatus.Finalized:
            return { label: t('status.FINALIZED'), color: 'green' };
        case PublicationStatus.Scheduled:
            return { label: t('status.SCHEDULED'), color: 'blue' };
        case PublicationStatus.InProgress:
            return { label: t('status.IN_PROGRESS'), color: 'var(--text-color-orange)' };
        case PublicationStatus.Stopped:
            return { label: t('status.STOPPED'), color: 'gray' };
        case PublicationStatus.StopPending:
            return { label: t('status.STOP_PENDING'), color: 'orange' };
        case PublicationStatus.Finished:
            return { label: t('status.FINISHED'), color: 'gray' };
        case PublicationStatus.Failed:
            return { label: t('status.FAILED'), color: 'red' };
        case PublicationStatus.Cancelled:
            return { label: t('status.CANCELLED'), color: 'gray' };
        default:
            return { label: t('status.UNKNOWN'), color: 'gray' };
    }
};

export const getEngagementRate = (average_views: number, subscribers_count: number) => {
    const engagementRate =
        subscribers_count > 0
            ? +((average_views / subscribers_count) * 100).toFixed(2)
            : 0;
    return engagementRate
}
export const openSupportLink = () => {
    const url = import.meta.env.VITE_APP_SUPPORT_LINK
    window.Telegram?.WebApp.openTelegramLink(url);
    window.Telegram?.WebApp?.ready();
}
export const openSuscribeLink = () => {
    const url = import.meta.env.VITE_APP_SUBSCRIBE_LINK
    window.Telegram?.WebApp.openTelegramLink(url);
    window.Telegram?.WebApp?.ready();
}